/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Plain_Text_Import_Read_Error_With_Message_ToastInputs */



/**
* | output |
* | --- |
* | "Error reading file: {error}" |
*
* @param {Plain_Text_Import_Read_Error_With_Message_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_read_error_with_message_toast = /** @type {((inputs: Plain_Text_Import_Read_Error_With_Message_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Read_Error_With_Message_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur de lecture du fichier : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Lesen der Datei: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante la lettura del file: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при чтении файла: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al leer el archivo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`读取文件时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ファイル読み取りエラー: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़ाइल पढ़ने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao ler o arquivo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error reading file: ${i?.error}`)
});